// import logo from './logo.svg';
import React from 'react';
/* eslint-disable react/react-in-jsx-scope */
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/js/bootstrap.min.js'
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css';
import '../src/assets/styles/styles.scss';
import './App.css';
import AboutGallery from './pages/about-gallery';
import AboutUs from './pages/aboutUs';
import AcademicLife from './pages/academicLife';
import AcademicVacancies from './pages/academicVacancies';
import AdministrativeVacancies from './pages/administrativeVacancies';
import Admissions from './pages/admissions';
import AlumniBenefits from './pages/alumni-benefits';
import AlumniEventsAndReunion from './pages/alumni-events-and-reunion';
import AlumniGallery from './pages/alumni-gallery';
import AlumniPage from './pages/alumni';
import AlumniStayConnected from './pages/alumni-stay-connected';
import Auditorium from './pages/auditorium';
import Blogs from './pages/blogs';
import Cafeteria from './pages/cafeteria';
import ClassActivities from './pages/classActivities';
import ClubsPage from './pages/clubs';
import CoCoSummerOfFun from './pages/coco-summer-of-fun';
import ContactUs from './pages/contactUs';
import Curriculum from './pages/curriculum';
import EventsAndActivities from './pages/eventsAndActivities';
import EventsInauguration from './pages/eventsInauguration';
import EventSportsPage from './pages/eventSports';
import FaculityProjects from './pages/facultyProjects';
import Facilities from './pages/facilities';
import FestsPage from './pages/fests';
// import GymPage from './pages/gym';
import Hackathon from './pages/hackathon';
import HomePage from "../src/pages/home";
import HostelsPage from './pages/hostels';
import InnerBlogs from './pages/innerBlogs';
import InspiringStories from './pages/inspiringStories';
import InternshipOneYear from './pages/internshipOneYear';
import InternshipThreeMonth from './pages/internshipThreeMonth';
import Internships from './pages/internships';
import MainLayout from "../src/components/layout/MainLayout";
import NewsAndUpdates from './pages/newsAndUpdates';
import NewsArticles from './pages/newsArticles';
import OurPeople from './pages/ourPeople';
import PageNotFound from './pages/pageNotFound';
import PastActivities from './pages/pastActivities';
import PlacedStudents from './pages/placedStudents';
import Placements from './pages/placements';
import Projects from './pages/projects';
import SportsPage from './pages/sports';
import StayConnected from './pages/stayConnected';
import StudentProjects from './pages/studentProjects';
import TransformationNewArticles from './pages/transformation-new-articles';
import TransformationStories from './pages/transformationStories';
import UniversityEvent from './pages/university-events';
import UniversityLife from './pages/universityLife';
import UpcomingActivities from './pages/upcomingActivities';
import WhoWeAre from './pages/whoWeAre';
import WorkWithUs from './pages/workWithUs';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
        <Route path="/contact-us" element={<MainLayout><ContactUs /></MainLayout>} />
        <Route path="/why-sitare" element={<MainLayout><AboutUs /></MainLayout>} />
        <Route path="/who-we-are" element={<MainLayout><WhoWeAre /></MainLayout>} />
        <Route path="/our-people" element={<MainLayout><OurPeople /></MainLayout>} />
        <Route path="/work-with-us" element={<MainLayout><WorkWithUs /></MainLayout>} />
        <Route path="/academic-vacancies" element={<MainLayout><AcademicVacancies /></MainLayout>} />
        <Route path="/administrative-vacancies" element={<MainLayout><AdministrativeVacancies /></MainLayout>} />
        <Route path="/academic-Life" element={<MainLayout><AcademicLife /></MainLayout>} />
        <Route path="/student-projects" element={<MainLayout><StudentProjects /></MainLayout>} />
        {/* <Route path="/Hackathon" element={<MainLayout><Hackathon /></MainLayout>} /> */}
        <Route path="/internships" element={<MainLayout><Internships /></MainLayout>} />
        <Route path="/curriculum" element={<MainLayout><Curriculum /></MainLayout>} />
        <Route path="/student-projects" element={<MainLayout><StudentProjects /></MainLayout>} />
        <Route path="/hackathon" element={<MainLayout><Hackathon /></MainLayout>} />
        <Route path="/blogs" element={<MainLayout><Blogs /></MainLayout>} />
        <Route path="/blogs/inner-blogs" element={<MainLayout><InnerBlogs /></MainLayout>} />
        {/* <Route path="/why-sitare" element={<MainLayout><WhySitare /></MainLayout>} /> */}
        <Route path="/projects" element={<MainLayout><Projects /></MainLayout>} />
        <Route path="/events-activities" element={<MainLayout><EventsAndActivities /></MainLayout>} />
        <Route path="/class-activities" element={<MainLayout><ClassActivities /></MainLayout>} />
        <Route path="/past-activities" element={<MainLayout><PastActivities /></MainLayout>} />
        <Route path="/upcoming-activities" element={<MainLayout><UpcomingActivities /></MainLayout>} />
        <Route path="/events-inauguration" element={<MainLayout><EventsInauguration /></MainLayout>} />
        <Route path="/university-life" element={<MainLayout><UniversityLife /></MainLayout>} />
        <Route path="/facilities" element={<MainLayout><Facilities /></MainLayout>} />
        <Route path="/news-updates" element={<MainLayout><NewsAndUpdates /></MainLayout>} />
        <Route path="/hostels" element={<MainLayout><HostelsPage /></MainLayout>} />
        <Route path="/cafeteria" element={<MainLayout><Cafeteria /></MainLayout>} />
        {/* <Route path="/gym" element={<MainLayout><GymPage /></MainLayout>} /> */}
        <Route path="/sports" element={<MainLayout><SportsPage /></MainLayout>} />
        <Route path="/auditorium" element={<MainLayout><Auditorium /></MainLayout>} />
        <Route path="/clubs" element={<MainLayout><ClubsPage /></MainLayout>} />
        <Route path="/fests" element={<MainLayout><FestsPage /></MainLayout>} />
        <Route path="/eventsports" element={<MainLayout><EventSportsPage /></MainLayout>} />
        <Route path="/faculty-projects" element={<MainLayout><FaculityProjects /></MainLayout>} />
        <Route path="/transformation-new-articles" element={<MainLayout><TransformationNewArticles /></MainLayout>} />
        <Route path="/placements" element={<MainLayout><Placements /></MainLayout>} />
        <Route path="/internship-one-year" element={<MainLayout><InternshipOneYear /></MainLayout>} />
        <Route path="/inspiring-stories" element={<MainLayout><InspiringStories /></MainLayout>} />
        <Route path="/news-articles" element={<MainLayout><NewsArticles /></MainLayout>} />
        <Route path="/internship-three-month" element={<MainLayout><InternshipThreeMonth /></MainLayout>} />
        <Route path="/internship-three-month" element={<MainLayout><InternshipThreeMonth /></MainLayout>} />
        <Route path="/coco-summer-of-fun" element={<MainLayout><CoCoSummerOfFun /></MainLayout>} />
        <Route path="/transformation-stories" element={<MainLayout><TransformationStories /></MainLayout>} />
        <Route path="/placed-students" element={<MainLayout><PlacedStudents /></MainLayout>} />
        <Route path="/admissions" element={<MainLayout><Admissions /></MainLayout>} />
        <Route path="/alumni" element={<MainLayout><AlumniPage /></MainLayout>} />
        <Route path="/alumni-benefits" element={<MainLayout><AlumniBenefits /></MainLayout>} />
        <Route path="/alumni-stay-connected" element={<MainLayout><AlumniStayConnected /></MainLayout>} />
        <Route path="/alumni-events" element={<MainLayout><AlumniEventsAndReunion /></MainLayout>} />
        <Route path="/alumni-gallery" element={<MainLayout><AlumniGallery /></MainLayout>} />
        <Route path="/stay-connected" element={<MainLayout><StayConnected /></MainLayout>} />
        <Route path="/university-event" element={<MainLayout><UniversityEvent /></MainLayout>} />
        <Route path="/about-gallery" element={<MainLayout><AboutGallery /></MainLayout>} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
